import React, { CSSProperties } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const StyledButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '15px',
  width: '100%',
  height: '45px',
  padding: '12px 24px',
  margin: 2,
  textTransform: 'none',
}));

const TextSpan = styled('span')({
  flexGrow: 1,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  textAlign: 'center',
  fontFamily: 'Oswald, sans-serif',
  lineHeight: '1.2',
  fontSize: '19px',
  color: 'white',
  paddingLeft: '12px',
  paddingRight: '12px',
});

const IconSpan = styled('span')({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  right: '9px',
  top: '50%',
  transform: 'translateY(-50%)',
});

export type GradientButtonProps = {
  text: string;
  showArrowIcon?: boolean;
  handleClick: () => void;
  styles?: CSSProperties;
};

export const OrangeGradient: CSSProperties = {
  background: 'linear-gradient(90deg, rgba(140, 20, 20, 0.86) 0%, #F27C22 100%)',
};

export const GradientButton: React.FC<GradientButtonProps> = (props) => {
  return (
    <StyledButton style={{ ...props.styles, ...OrangeGradient }} variant='contained' onClick={props.handleClick}>
      <TextSpan>{props.text}</TextSpan>

      {props.showArrowIcon && ( // only show if condition is true
        <IconSpan>
          <ArrowForwardIosIcon fontSize='medium' style={{ color: 'white' }} />
        </IconSpan>
      )}
    </StyledButton>
  );
};
